import React, { useContext } from "react"

import { ScreenContext } from "./Providers/Screen"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import G2Badges from "components/features/G2Badges"
import G2BadgesMobile from "components/features/G2BadgesMobile"
import Cards from "./features/Cards"
import Grid from "./features/Grid"
import useMedia from "utils/useMedia"
import ReactPlayer from "react-player"
import Comparison from "./Comparison"
import Stats from "./features/Stats"
import { FaBorderNone } from "react-icons/fa"
import StyledLink from "./StyledLink"

const Features = ({ content }) => {
  const { mobile } = useContext(ScreenContext)
  const videoWidth = useMedia("912px", "63.333vw", "89.063vw", "87.85vw")
  const videoHeight = useMedia("512px", "35.556vw", "50vw", "49.299vw")

  const componentToUse = (param, content) => {
    switch (param) {
      case "Comparison":
        return content.comparison ? (
          <Comparison content={content.comparison} />
        ) : (
          false
        )
      case "3-Card":
      case "4-Card":
        return content.cards ? <Cards cardData={content} /> : false
      case "3x3":
      case "4x4":
        return content.grid ? <Grid gridData={content} /> : false
      case "G2Badges":
        return content.badges ? (
          !mobile ? (
            <G2Badges badges={content.badges} />
          ) : (
            <G2BadgesMobile badges={content.badges} />
          )
        ) : (
          false
        )
      case "Video":
        return content.video ? (
          <Video
            url={content.video}
            controls={true}
            light={content.videoThumbnail?.sourceUrl}
            playing={true}
            volume={1}
            muted={false}
            width={videoWidth}
            height={videoHeight}
            playIcon={false}
            // style={}
          />
        ) : (
          false
        )
      case "Image":
        return content.image ? (
          <Image alt={content.imageAlt} src={content.image.sourceUrl} />
        ) : (
          false
        )
      case "Stats":
        return content.stats ? <Stats content={content.stats} /> : false
      default:
        return false
    }
  }

  const component = componentToUse(content.variation, content)
  return (
    <Wrapper g2={content?.badges} textColor={content?.textColor}>
      <IntroDiv>
        {content?.eyebrow && <Eyebrow>{content?.eyebrow}</Eyebrow>}
        {content?.header && !content?.imageHeader && (
          <Header $headersize={content?.headerSize}>{content?.header}</Header>
        )}
        {content?.imageHeader && content?.headerImage?.sourceUrl && (
          <HeaderImg
            $noMargin={content?.introBody ? false : true}
            src={content?.headerImage.sourceUrl}
            alt={content?.headerImage.altText}
          />
        )}
        {content?.introBody && (
          <IntroBody bold={content?.bodyBold}>{content?.introBody}</IntroBody>
        )}
        {content?.linkUrl && content?.linkText && (
          <StyledLink href={content?.linkUrl} color={colors.primaryOrange}>
            {content?.linkText}
          </StyledLink>
        )}
      </IntroDiv>
      {component}
    </Wrapper>
  )
}

const Video = styled(ReactPlayer)`
  .react-player__shadow {
    display: none !important;
  }
`

const Image = styled.img`
  width: 63.333vw;

  ${media.fullWidth} {
    width: 912px;
  }

  ${media.tablet} {
    width: 89.063vw;
  }

  ${media.mobile} {
    width: 100vw;
  }
`

const IntroBody = styled.p`
  ${props => (props.bold ? `${text.bodyMdBold}` : `${text.bodyMd}`)};

  text-align: center;
  width: 63.333vw;

  ${media.fullWidth} {
    width: 912px;
  }

  ${media.tablet} {
    width: 80.469vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`

const HeaderImg = styled.img`
  height: 9.097vw;
  width: 31.944vw;
  margin-bottom: ${props => (props.$noMargin ? "unset" : "1.667vw")};
  margin-top: ${props => (props.$noMargin ? "unset" : "2.778vw")};

  ${media.fullWidth} {
    height: 131px;
    width: 460px;
    margin-top: ${props => (props.$noMargin ? "unset" : "40px")};
    margin-bottom: ${props => (props.$noMargin ? "unset" : "24px")};
  }

  ${media.tablet} {
    height: 12.793vw;
    width: 100%;
    margin-bottom: ${props => (props.$noMargin ? "unset" : "2.344vw")};
    margin-top: ${props => (props.$noMargin ? "unset" : "3.906vw")};
  }

  ${media.mobile} {
    width: 100%;
    height: 26.402vw;
    margin-top: ${props => (props.$noMargin ? "unset" : "9.346vw")};
  }
`
const Header = styled.h2`
  ${props => (props.$headersize ? `${text.h3}` : `${text.h2}`)}

  ${media.mobile} {
    ${text.h2};
  }
`

const Eyebrow = styled.p`
  ${text.eyebrow};
`
const IntroDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1.667vw;
  margin-bottom: 4.167vw;

  ${media.fullWidth} {
    gap: 24px;
    margin-bottom: 60px;
  }

  ${media.tablet} {
    gap: 3.906vw;
    margin-bottom: 3.906vw;
  }

  ${media.mobile} {
    gap: 9.346vw;
    margin-bottom: 9.346vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  color: ${props => (props.textColor ? `#${props.textColor}` : "white")};
  width: 100%;
  padding: 0 10.278vw;

  ${media.fullWidth} {
    padding: 0 148px;
  }

  ${media.tablet} {
    padding: 0 3.906vw;
  }

  ${media.mobile} {
    padding: 0 6.075vw;
  }
`
export default Features
